// Tiny heart-shaped favourite button — no business logic, just visual.
import type { CSSProperties, JSX, MouseEvent } from "react";
import { Heart } from "lucide-react";
import { useT } from "@/shared/i18n";

interface Props {
  active: boolean;
  onClick: (e: MouseEvent) => void;
  /** Override the default className (used by the catalog card). */
  className?: string;
  /** Override the default size (used by the product detail page). */
  size?: number;
  style?: CSSProperties;
}

export function FavoriteIcon({ active, onClick, className, size = 19, style }: Props): JSX.Element {
  const { t } = useT();
  return (
    <button
      type="button"
      className={className}
      aria-label={active ? t("favorites.aria_remove") : t("favorites.aria_add")}
      onClick={onClick}
      style={style}
    >
      <Heart
        size={size}
        strokeWidth={1.8}
        fill={active ? "#e13a3a" : "none"}
        stroke={active ? "#e13a3a" : "currentColor"}
        aria-hidden="true"
      />
    </button>
  );
}
